import { createFileRoute } from "@tanstack/react-router";
import { DashboardPage } from "@/shared/pages/dashboard";

export const Route = createFileRoute("/_protected/dashboard")({
  component: DashboardPage,
});
